export enum TruckRoles {
  ADMIN = 'admin',
  SAFETY_MANAGER = 'safety_manager',
  DRIVER = 'driver',
  DISPATCHER = 'dispatcher',
}
